import { render, staticRenderFns } from "./GiveFeedback.vue?vue&type=template&id=c2429580&"
import script from "./GiveFeedback.vue?vue&type=script&lang=js&"
export * from "./GiveFeedback.vue?vue&type=script&lang=js&"
import style0 from "./GiveFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports